export enum WorkspaceDocumentType {
  TECHNICAL_MEMO = 'TECHNICAL_MEMO',
  RESPONSE_FRAMEWORK = 'RESPONSE_FRAMEWORK',
  CLIENT_REFERENCES = 'CLIENT_REFERENCES',
  CV = 'CV',
  DATA_POLICY = 'DATA_POLICY',
  CSR_POLICY = 'CSR_POLICY',
  CERTIFICATION = 'CERTIFICATION',
  PRODUCT_SHEET = 'PRODUCT_SHEET',
  OTHER = 'OTHER',
  UNKNOWN = 'UNKNOWN',
}

export type WorkspaceDocument = {
  id: number;
  originalName: string;
  prettyName: string;
  S3FileURL: string;
  S3PreviewFileURL: string;
  type: WorkspaceDocumentType | null;
  workspaceId: number;
  archivedAt: Date | null;
};

export type NewWorkspaceDocument = Omit<
  WorkspaceDocument,
  'id' | 'archivedAt'
> & { archivedAt: null };
